import * as ActionTypes from '../constants/actionTypes';

export function addToHomeScreen(state) {
    return {
        type: ActionTypes.ADD_TO_HOME_SCREEN,
        payload: state
    };
}